import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { UserPublicProfile } from "../../UserProfile/UserPublicProfile";
import { UserStickerListWithInfinityScroll, useUserVideos } from "../../UserProfile";
import { Loading } from "@parkschannel/ui";
export const UserPublicProfileParksPage = (param)=>{
    let { query: { id  }  } = param;
    const { useUserStickersInfiniteQuery  } = useUserVideos();
    const { data: stickers , isLoading , fetchNextPage , isFetchingNextPage , hasNextPage  } = useUserStickersInfiniteQuery(id, {
        page: 1,
        limit: 30,
        search: null
    });
    return /*#__PURE__*/ _jsx(UserPublicProfile, {
        id: id,
        children: isLoading ? /*#__PURE__*/ _jsx(Loading, {}) : stickers ? /*#__PURE__*/ _jsx(UserStickerListWithInfinityScroll, {
            data: stickers,
            fetchNextPage: fetchNextPage,
            hasNextPage: hasNextPage,
            isFetchingNextPage: isFetchingNextPage
        }) : null
    });
};
